export const PUBLISHER_PARTNERS = [
  {
    language : 'ru',
    title    : 'Дмитрий Тарахно',
    subtitle : 'Руководитель «Овощи Медиа»',
    image    : require('./img/publisher/partners/tarahno.jpg'),
    text     : `Я начал сотрудничать с CityAds в 2012 г. и продолжаю до сих пор. Пять лет — это очень долгий срок
    для такой динамичной отрасли. Я работал с различными вертикалями, и CityAds всегда могли предложить широкий выбор
    горячих офферов с разнообразной географией в области мобильного контента, приложений, финансов, игр и электронной
    коммерции. Несомненные преимущества CityAds – это своевременные платежи, отзывчивые аккаунт-менеджеры и готовность
    предлагать индивидуальные условия. Благодаря City мой бизнес развивался ускоренными темпами все эти годы.
    Настоятельно рекомендую.`
  },
  {
    language : 'en',
    title    : 'Dmitry Tarakhno',
    subtitle : 'CEO Ovoshi Media.',
    image    : require('./img/publisher/partners/tarahno.jpg'),
    text     : `I have been working with Cityads since 2012, for 5 years already which is pretty much for this
    everchanging industry. I have worked with different verticals and Cityads could always offer a wide range of
    hot and actual offers in mobile content, apps, finance, games, ecommerce in multiple geos. On time payments,
    extremely responsive account managers in Cityads and their willingness to offer individual conditions helped me
    to grow my business at great velocity over these years.`
  },
  {
    language : 'ru',
    title    : 'Алёна Сидоренко',
    subtitle : 'Операционный директор ООО «Смартлидс»',
    image    : require('./img/publisher/partners/sidorenko.jpg'),
    text     : `В CityAds представлено большое количество российских и зарубежных офферов в различных вертикалях, много
    эксклюзивов. Менеджеры всегда на связи, оперативно решают задачи и способствуют достижению общих целей вебмастера,
    рекламодателя и самой партнерской сети. Отдельно хочу отметить невероятно подробную статистику, юзабилити личного
    кабинета и своевременные оповещения об изменениях в офферах.`
  },
  {
    language: 'en',
    title    : 'Christos Proitsis',
    subtitle : 'Director at VIP Affiliate Network LTD',
    image    : require('./img/publisher/partners/vipan.png'),
    text     : `Working with CityAds has been a very pleasant experience. Tracking is excellent and the range
    of programs is huge. Moreover, CityAds covers almost any possible market and segment.
    On top of that, our AM has been extremely proactive when it comes to introducing us to new programs, handing
    payments on time etc. I would definitely recommend CityAds to any potential publisher!`
  },
  {
    language: 'ru',
    title: 'Christos Proitsis',
    subtitle: 'Director at VIP Affiliate Network LTD',
    image: require('./img/publisher/partners/vipan.png'),
    text: `Работать с CityAds было очень приятно. Система отслеживания работает превосходно, а спектр программ огромен. Более того, CityAds охватывает практически любой возможный рынок и сегмент.
    Вдобавок ко всему, наш аккаунт-менеджер проявляет невероятную инициативность, знакомя нас с новыми программами, своевременно обеспечивая выплаты и так далее. Я определенно рекомендую CityAds любому потенциальному вебмастеру!`
  },
  {
    language : 'ru',
    title    : 'Радослав Тышко',
    subtitle : 'Генеральный менеджер Picodi.com',
    image    : require('./img/publisher/partners/picodi.png'),
    text     : `В команде CityAds работают настоящие профессионалы, которые в полной мере понимают потребности как
    рекламодателей, так и рекламных площадок. Благодаря взаимовыгодному сотрудничеству с CityAds мы смогли увеличить
    монетизацию и удовлетворить потребности наших пользователей.`
  },
  {
    language : 'ru',
    title    : 'Антон Картузов',
    subtitle : 'backly.ru',
    image    : require('./img/publisher/partners/backly.png'),
    text     : `CityAds – наши основные партнеры, с которыми мы сотрудничаем уже больше года, и это сотрудничество
    хочется продолжать! Эти ребята работают действительно профессионально, быстро решают все проблемы и по многим
    вопросам готовы пойти навстречу. Я очень доволен переходом на CityAds, и мы будем только рады подключить новые
    офферы через вашу сеть. Отдельно хочу поблагодарить Илью, Сергея и сотрудников финансового отдела. Работать
    с вами — одно удовольствие, в процессе работы не возникает даже намека на какие-то проблемы! City, призываю вас не
    останавливаться на достигнутом и развивать новые продукты. Желаю успехов!`
  },
  {
    language : 'ru',
    title    : 'Александр Лученок',
    subtitle : 'VIP-партнер',
    image    : require('./img/publisher/partners/luchenok.jpg'),
    text     : `Я работаю с партнерской программой CityAds уже несколько месяцев и, честно говоря, нахожусь в полном
    восторге. Это первая партнерская программа, с которой мне удается стабильно и много зарабатывать. Я выбрал
    несколько подходящих офферов и в первые же дни получил несколько конверсий со своих пабликов и тем на форумах.
    Выплаты осуществляются каждые две недели, точно в срок. Минимальная сумма для вывода просто смешная — 30$,
    которые можно заработать буквально за пару дней. При этом вы получаете каждый свой честно заработанный цент
    (в отличие от некоторых других партнерок, которые не брезгуют разводом). Можно выбрать более удобную валюту,
    например, гривны или рубли. Есть возможность заказать перевод денег на платежные системы, такие как Webmoney
    и Яндекс.Деньги. В поддержке работают вежливые и адекватные люди, которые почти круглосуточно находятся на связи,
    отвечают на все возникающие вопросы и помогают справиться с проблемами. Надеюсь, что CityAds и дальше будут
    увеличивать количество офферов со всего мира.`
  },
];

export const ADVERTISER_PARTNERS_RU = [
  {
    title    : 'Adv Cake',
    subtitle : 'Рекламные технологии',
    image    : require('./img/advertiser/partners/advcake.png'),
    imageAlt : 'Adv Cake',
    text     : `Отличная команда профессионалов, нацеленная на результат. Любые вопросы решаются максимально быстро и
    самым оптимальным образом! Очень удобный, многофункциональный личный кабинет со всей необходимой информацией.
    Отдельно хочется сказать спасибо всем аккаунт-менеджерам, вы большие молодцы!`
  },
  {
    title    : 'Александр Мальцев',
    subtitle : 'Head of B2C marketing emerging Europe',
    image    : require('./img/advertiser/partners/ebay.png'),
    imageAlt : 'eBay',
    text     : `Мы работаем с CityAds c 2014 года. За это время мы расширили географию работы до 179 стран. Команда CityAds
    решает все вопросы оперативно и наша совместная работа приносит хорошие результаты. Рекомендую.`
  },
  {
    title    : 'Алина Сухарева',
    subtitle : 'Менеджер по развитию глобального маркетинга',
    image    : require('./img/advertiser/partners/shutterstock.png'),
    imageAlt : 'shutterstock',
    text     : `Работать с CityAds - настоящее удовольствие. Мы в кратчайшие сроки начали сотрудничество и запустили
    рекламную кампанию.`
  },
  {
    title    : 'Kredito24',
    subtitle : 'Быстрые займы онлайн',
    image    : require('./img/advertiser/partners/kredito24.png'),
    imageAlt : 'Kredito24',
    text     : `Наша компания сотрудничает с CityAds уже более двух лет, и мы можем с уверенностью сказать, что это
    одна из лучших партнерских сетей на рынке Рунета. За время нашего сотрудничества CityAds привлекла на наш сайт
    несколько сотен тысяч лидов, причем по очень демократичным расценкам. Проверенные рекламные площадки
    и качественный целевой трафик. Желаем CityAds успехов и дальнейшего развития!`
  },
  {
    title    : 'Артём Аманов',
    subtitle : 'Руководитель отдела продвижения и прямого привлечения клиентов',
    image    : require('./img/advertiser/partners/stoloto.png'),
    imageAlt : 'Столото',
    text     : `Мы довольны результатами, показателями и уникальными технологиями CityAds, которые позволяют нам
    достигать поставленных целей. Отдельная благодарность команде за качественный сервис, профессиональную помощь
    и экспертизу.`
  },
  {
    title    : 'Анна Манвелян',
    subtitle : 'Менеджер по партнерскому маркетингу',
    image    : require('./img/advertiser/partners/tinkoff.png'),
    imageAlt : 'Тинькофф Банк',
    text     : `CityAds — наш ключевой партнер по CPA-продвижению в Рунете. Компания оказывает качественный сервис,
    ее технологии обеспечивают максимально точный таргетинг на целевую аудиторию.`
  },
  {
    title    : 'Иван Кузнецов',
    subtitle : 'Директор по маркетингу',
    image    : require('./img/advertiser/partners/gaijin.png'),
    imageAlt : 'Gaijin',
    text     : `Уже более 7 лет CityAds является одним из ключевых партнеров по маркетинговой поддержке наших продуктов.
    Спасибо команде за сервис, оперативность и эффективность выполняемых работ.`
  },
  {
    title    : 'Ирина Мальцева',
    subtitle : 'Генеральный директор',
    image    : require('./img/advertiser/partners/susimaster.png'),
    imageAlt : 'СушиМастер',
    text     : `Выражаем благодарность команде CityAds за профессиональный
    подход, достигнутые результаты в рамках нашего сотрудничества и оперативные решения во всех возникающих вопросах.`
  },
];

export const ADVERTISER_PARTNERS_EN = [
  {
    title    : 'Jane Lu',
    subtitle : 'Affiliate Executive',
    image    : require('./img/advertiser/partners/tvcmall.png'),
    imageAlt : 'TVCMALL',
    text     : `Working with CityAds helped us achieve significant growth in the business. Their in-depth
    analytics, efficient tools, prompt response to our requests, and constant support at every stage made
    our advertising campaigns successful and profitable.`
  },
  {
    title    : 'Weason Tan',
    subtitle : 'Partnership Executive',
    image    : require('./img/advertiser/partners/dhgate.png'),
    imageAlt : 'DHGate',
    text     : `CityAds is one of affiliate networks we have been collaborating for a long time. The most
    charming part for me, is the professional manager. CityAds and our dedicated manager make our
    communications with partners much high effective and positive. DHGate would grow with CityAds for
    next decade.`
  },
  {
    title    : 'Arthur Fogelis',
    subtitle : 'Affiliate Manager',
    image    : require('./img/advertiser/partners/asaptickets.png'),
    imageAlt : 'AsapTickets',
    text     : `It's always easy to communicate and work with CityAds. The account managers are very helpful
    and proactive in ensuring our campaigns achieve great results.`
  },
  {
    title    : 'Azusa Zheng',
    subtitle : 'Manager Banggood Affiliate Team',
    image    : require('./img/advertiser/partners/banggood.png'),
    imageAlt : 'Banggood',
    text     : `We express our gratitude to the CityAds for the fruitful cooperation. Thanks to the company
    we managed to attract many new clients.`
  },
  {
    title    : 'Justina Banytė',
    subtitle : 'Affiliate Marketing Manager',
    image    : require('./img/advertiser/partners/surfshark.png'),
    imageAlt : 'Surfshark',
    text     : `Working with City Ads has been a positive experience overall. They are responsive and
    professional, and their publishers have delivered steady results since the beginning of our partnership.
    While there are areas that could be further refined, the team at City Ads is committed to making
    adjustments and changes, and we're hopeful for continued improvements moving forward.`
  },
  {
    title    : 'Mira James',
    subtitle : 'Account manager',
    image    : require('./img/advertiser/partners/veepn.png'),
    imageAlt : 'VeePN',
    text     : `We would like to thank for the successful cooperation and trust. We appreciate your efforts
    and energy in developing joint campaigns. Over the past months of cooperation with CityAds our
    commission has almost doubled due to the attraction of new publishers.`
  },
  {
    title    : 'Piotr Opara',
    subtitle : 'Publisher Team Leader',
    image    : require('./img/advertiser/partners/wedare.png'),
    imageAlt : 'Agency Wedare',
    text     : `We have been collaborating closely with Cityads for five years, and I would like
    to highlight how their team has played a significant role in helping us achieve our objectives through
    their creative approach, innovative adtech products, and understanding of our needs. They play
    a significant part in the strategies we develop for our clients.`
  },
  {
    title    : 'Dasha Vernikovskaya',
    subtitle : 'Affiliate Manager',
    image    : require('./img/advertiser/partners/crezu.png'),
    imageAlt : 'Crezu',
    text     : `We are glad to work with this partner. They are always ready to meet halfway and discuss
    all the details. We get good traffic in ES&LATAM, PL and are satisfied with the results.`
  },
  {
    title    : 'Marta Fila',
    subtitle : 'Chief Sales Office',
    image    : require('./img/advertiser/partners/supergrosz.png'),
    imageAlt : 'SuperGrosz.pl',
    text     : `Cityads is a professional, experienced and trusted partner with whom we have been
    cooperating since 2016. We value the transparency, flexibility and support of the Cityads team
    at every stage of our joint activities.Our dedicated Account Manager is in constant contact with us
    and we can always count on his support.`
  },
];

export const ADVERTISER_PARTNERS_VI = [
  {
    title    : 'Artem Andreev',
    subtitle : 'CEO',
    image    : require('./img/advertiser/partners/drdong.png'),
    imageAlt : 'Doctor Dong',
    text     : `Công ty chúng tôi - Doctor Dong đã hợp tác với Cityads Việt Nam hơn 3 năm và trong suốt
    quá trình làm việc, Cityads luôn là một đối tác đáng tin cậy. Trải qua nhiều giai đoạn bao gồm khi
    phát triển thịnh vượng lẫn lúc khó khăn, nhưng đội ngũ Cityads luôn đồng hành với sự hỗ trợ nhiệt
    tình và tích cực nhất. Tháng vừa qua, chúng tôi đã có thể khôi phục lại trạng thái cân bằng trước
    dịch bệnh. Vì thế, chúng tôi chắc chắn sẽ không dừng lại đó mà cùng nhau tiến xa hơn thời gian tới!`
  },
  {
    title    : 'Nikita Yaroshenko',
    subtitle : 'CEO',
    image    : require('./img/advertiser/partners/capitalsolution.png'),
    imageAlt : 'Capital Solution',
    text     : `Chúng tôi thực sự ấn tượng khi hợp tác với CityAds Việt Nam. Sự tăng trưởng bền vững
    trong suốt quá trình hợp tác đến từ cách làm việc chuyên nghiệp của đội ngũ CityAds là điều chúng
    tôi tin tưởng để lựa chọn đây là đối tác hàng đầu của VayVND trong lĩnh vực CPA cho Thị trường Việt Nam!`
  },
  {
    title    : 'Alexander Pyrsikov',
    subtitle : 'Senior Affiliate Manager',
    image    : require('./img/advertiser/partners/exness.png'),
    imageAlt : 'Exness',
    text     : `CityAds Media giúp chúng tôi tiếp cận người dùng chất lượng cao chủ yếu ở các khu vực Đông
    Nam Á và Nam Á. Chúng tôi bắt đầu hợp tác với nhau chưa đầy 6 tháng trước. Đến thời điểm này, chúng tôi
    có thể nói rằng CityAds đã được xem là một trong những đối tác chiến lược của Exness. Họ liên tục thể
    hiện kết quả tốt và quản lý mọi vấn đề kinh doanh với thái độ chuyên nghiệp. Chúng tôi chắc chắn rằng
    CityAds cũng sẽ giúp Exness đạt được các mục tiêu tiếp thị của mình ở các quốc gia khác, nơi mà tiềm
    năng kinh doanh là không giới hạn.`
  },
  {
    title    : 'Natalya Kovalenko',
    subtitle : 'CEO',
    image    : require('./img/advertiser/partners/oneclickmoney.png'),
    imageAlt : 'OneClickMoney',
    text     : `Cityads Việt Nam đã là đối tác của chúng tôi trong hơn một năm qua. Trong thời gian này,
    Cityads Việt Nam luôn khẳng định được mình ở phương diện tích cực. Chúng tôi mong duy trì mối quan
    hệ hợp tác hiệu quả này trong tương lai và tiếp tục ghi nhận sự tăng trưởng liên tục của các chuyển đổi!`
  },
  {
    title    : 'Ms Vân',
    subtitle : 'Senior Performance Marketing Manager',
    image    : require('./img/advertiser/partners/mytour.png'),
    imageAlt : 'Mytour',
    text     : `Sản phẩm hiện cần hoàn thiện hơn, mảng du lịch đang khôn mang lại
    nhiều đơn hàng, tuy nhiên là 1 kênh chuyển đổi tiềm năng để sử dụng lâu dài. Hy vọng thay đổi
    thêm hiệu suất để mang lại nhiều chuyển đổi hơn`
  },
  {
    title    : 'Ms Châu',
    subtitle : 'Marketing Manager',
    image    : require('./img/advertiser/partners/fpt.png'),
    imageAlt : 'FPT',
    text     : `Chúng tôi nhận thấy CityAds Media cung cấp giao diện tốt giúp Merchant dễ dàng theo
    dõi các chỉ số và hiệu suất hoạt động. Với nền tảng dữ liệu chất lượng, CityAds Media đã đưa ra
    các chiến dịch quảng cáo CPA bài bản cho tỷ lệ chuyển đổi lớn và mang lại hiệu quả cao.`
  },
]

export const ADVERTISER_PARTNERS_PL = [
  {
    title    : '',
    subtitle : '',
    image    : require('./img/advertiser/partners/easypaymentservices.png'),
    imageAlt : 'Easy Payment Services',
    text     : `Serdecznie polecam sieć afiliacyjną CityAds Media Polska, jako doświadczonego i kompetentnego partnera biznesowego, który realizuje powierzone zadania w sposób rzetelny i profesjonalny.
    Na podstawie zrealizowanych do tej pory kampanii, mogę potwierdzić bardzo dobrą jakość dostarczonych wyników.
    Współpracę z CityAds oceniam bardzo wysoko i liczę na dalszy, owocny rozwój naszych działań.`
  },
  {
    title    : 'Marcin Laskowski',
    subtitle : 'Affiliate Manager',
    image    : require('./img/advertiser/partners/aventusgrp.png'),
    imageAlt : 'Aventus Group',
    text     : `CityAds to zespół specjalistów na najwyższym poziomie. Kompetencje i wiedza połączone
     z pełnym profesjonalizmem to gwarancja udanej współpracy. Polecam każdemu, kto w swoich Partnerach
      ceni sprawność działania i nastawienie na grę Win-Win.`
  },
  {
    title    : 'Anna Seredyńska',
    subtitle : 'Senior Performance Media Specialist',
    image    : require('./img/advertiser/partners/intredo.png'),
    imageAlt : 'Intredo',
    text     : `Z firmą CityAds Media współpracujemy od kilku lat. W tym czasie, zrealizowali
    dla nas wiele zleceń na wysokim poziomie. Jesteśmy bardzo zadowoleni z dostarczonych wyników,
    dlatego zdecydowaliśmy się rozszerzyć nasze działania również na rynki zagraniczne. Z pełną
    odpowiedzialnością mogę polecić CityAds, jako sprawdzoną i rzetelną sieć afiliacyjną.`
  },
  {
    title    : 'Wojciech Kamiński',
    subtitle : 'Business Development Manager',
    image    : require('./img/advertiser/partners/fiizy.png'),
    imageAlt : 'Fiizy',
    text     : `Współpraca z zespołem CityAds to czysta przyjemność. Wszyscy są bardzo pomocni i
    bardzo rzetelni. Zawsze wszystko na czas, gorąco polecam współpracę z CityAds.`
  },
  {
    title    : 'Michał Rak',
    subtitle : 'Marketing Manager',
    image    : require('./img/advertiser/partners/konesso.png'),
    imageAlt : 'Konesso',
    text     : `Jestem bardzo zadowolony. Cenię sobie przede wszystkim szybki i rzetelny kontakt
    z opiekunem oraz dość intensywny rozwój naszych działań i zwiększanie sprzedaży.`
  },
]

export const ADVERTISER_PARTNERS_PT = [
  {
    title    : 'Gabriel Pinheiro',
    subtitle : 'Analista de Marketing',
    image    : require('./img/advertiser/partners/marabraz.png'),
    imageAlt : 'Marabraz',
    text     : `Trabalho com a CityAds a algum tempo e tem sido muito bom em todos os
    aspectos, sempre muito ágeis e eficientes, tem sido uma grande parceira para nós e isso só tende a aumentar.`
  },
  {
    title    : 'Tássia Vieira',
    subtitle : 'Analista de Marketing',
    image    : require('./img/advertiser/partners/compracerta.png'),
    imageAlt : 'Compra Certa',
    text     : `A CityAds demonstra muito trabalho em equipe, que é um de nossos valores
    que mais acreditamos que geram resultados. Com esse trabalho em equipe, estamos
    crescendo a parceria e estamos muito felizes com os números.`
  },
  {
    title    : 'Danilo Grava',
    subtitle : 'Head of Marketing',
    image    : require('./img/advertiser/partners/ecadeiras.png'),
    imageAlt : 'E-Cadeiras',
    text     : `O nosso relacionamento com a Cityads é muito bom. Essa proximidade e a
    sinceridade abre caminho para bons frutos. Cityads Team muito obrigada pelo empenho e carinho pela nossa empresa.`
  },
]

export const FEATURED_PAYMENT_METHODS = [
  {
    title: 'PayPal',
    image: require('./img/publisher/payment-methods/paypal.png'),
  },
  {
    title: 'Visa',
    image: require('./img/publisher/payment-methods/visa.png'),
  },
  {
    title: 'MasterCard',
    image: require('./img/publisher/payment-methods/mastercard.png'),
  },
  {
    title: 'Mir',
    image: require('./img/publisher/payment-methods/mir.png'),
  },
  {
    title: 'Capitalist',
    image: require('./img/publisher/payment-methods/capitalist.png'),
  },
  {
    title: 'Bank',
    image: require('./img/publisher/payment-methods/bank.png'),
  },
];

export const ADVERTISER_LOGOS_RU = [
  {
    title: 'Райффайзенбанк',
    image: require('./img/advertiser/logos/raiffeisenru.svg'),
  },
  {
    title: 'Альфа Банк',
    image: require('./img/advertiser/logos/alfabank.svg'),
  },
  {
    title: 'Кредито 24',
    image: require('./img/advertiser/logos/kredito24.svg')
  },
  {
    title: 'Росгосстрах',
    image: require('./img/advertiser/logos/rgs.svg')
  },
  {
    title: 'Aliexpress',
    image: require('./img/advertiser/logos/aliexpress.svg')
  },
  {
    title: 'Amazon',
    image: require('./img/advertiser/logos/amazon.svg')
  },
  {
    title: 'Столото',
    image: require('./img/advertiser/logos/stoloto.png')
  },
  {
    title: 'P&G',
    image: require('./img/advertiser/logos/png.svg')
  },
  {
    title: 'Coca-Cola',
    image: require('./img/advertiser/logos/cocacola.svg')
  },
  {
    title: 'Delivery Club / Mail.ru Group',
    image: require('./img/advertiser/logos/deliveryclub.svg')
  },
  {
    title: 'Wargaming',
    image: require('./img/advertiser/logos/wargaming.svg')
  },
  {
    title: 'Plarium',
    image: require('./img/advertiser/logos/plarium.png')
  },
  {
    title: 'Gaijin',
    image: require('./img/advertiser/logos/gaijin.png')
  },
  {
    title: 'Xsolla',
    image: require('./img/advertiser/logos/xsolla.svg')
  },
  {
    title: 'Marriott',
    image: require('./img/advertiser/logos/marriott.png')
  },
  {
    title: 'Agoda',
    image: require('./img/advertiser/logos/agoda.svg')
  },
  {
    title: 'Booking.com',
    image: require('./img/advertiser/logos/booking.svg')
  },
  {
    title: 'Skyscanner',
    image: require('./img/advertiser/logos/skyscanner.svg')
  },
];

export const ADVERTISER_LOGOS_EN = [
  {
    title: 'Райффайзенбанк',
    image: require('./img/advertiser/logos/raiffeisen.svg')
  },
  {
    title: 'CitiBank',
    image: require('./img/advertiser/logos/citibank.svg')
  },
  {
    title: 'Bradesco',
    image: require('./img/advertiser/logos/bradesco.png')
  },
  {
    title: 'Santander',
    image: require('./img/advertiser/logos/santander.png')
  },
  {
    title: 'Aliexpress',
    image: require('./img/advertiser/logos/aliexpress.svg')
  },
  {
    title: 'Amazon',
    image: require('./img/advertiser/logos/amazon.svg')
  },
  {
    title: 'P&G',
    image: require('./img/advertiser/logos/png.svg')
  },
  {
    title: 'Coca-Cola',
    image: require('./img/advertiser/logos/cocacola.svg')
  },
  {
    title: 'McDonald\'s',
    image: require('./img/advertiser/logos/mcdonalds.png')
  },
  {
    title: 'HP',
    image: require('./img/advertiser/logos/hp.png')
  },
  {
    title: 'Wargaming',
    image: require('./img/advertiser/logos/wargaming.svg')
  },
  {
    title: 'Plarium',
    image: require('./img/advertiser/logos/plarium.png')
  },
  {
    title: 'Gaijin',
    image: require('./img/advertiser/logos/gaijin.png')
  },
  {
    title: 'Xsolla',
    image: require('./img/advertiser/logos/xsolla.svg')
  },
  {
    title: 'Marriott',
    image: require('./img/advertiser/logos/marriott.png')
  },
  {
    title: 'Agoda',
    image: require('./img/advertiser/logos/agoda.svg')
  },
  {
    title: 'Booking.com',
    image: require('./img/advertiser/logos/booking.svg')
  },
  {
    title: 'Skyscanner',
    image: require('./img/advertiser/logos/skyscanner.svg')
  },
]

export const ADVERTISER_LOGOS_VI = [
  {
    title: 'Shopee',
    image: require('./img/advertiser/logos/shopee.svg')
  },
  {
    title: 'Lazada',
    image: require('./img/advertiser/logos/lazada.svg')
  },
  {
    title: 'Tiki',
    image: require('./img/advertiser/logos/tiki.png')
  },
  {
    title: 'Blibli',
    image: require('./img/advertiser/logos/blibli.svg')
  },
  {
    title: 'Nike',
    image: require('./img/advertiser/logos/nike.svg')
  },
  {
    title: 'Adidas',
    image: require('./img/advertiser/logos/adidas.svg')
  },
  {
    title: 'Exness',
    image: require('./img/advertiser/logos/exness.svg')
  },
  {
    title: 'DoctorDong',
    image: require('./img/advertiser/logos/doctordong.svg')
  },
  {
    title: 'Raiffeisen Bank',
    image: require('./img/advertiser/logos/raiffeisen.svg')
  },
  {
    title: 'CitiBank',
    image: require('./img/advertiser/logos/citibank.svg')
  },
  {
    title: 'Bradesco',
    image: require('./img/advertiser/logos/bradesco.png')
  },
  {
    title: 'Santander',
    image: require('./img/advertiser/logos/santander.png')
  },
  {
    title: 'Aliexpress',
    image: require('./img/advertiser/logos/aliexpress.svg')
  },
  {
    title: 'Amazon',
    image: require('./img/advertiser/logos/amazon.svg')
  },
  {
    title: 'P&G',
    image: require('./img/advertiser/logos/png.svg')
  },
  {
    title: 'Mcdonalds',
    image: require('./img/advertiser/logos/mcdonalds.png')
  },
  {
    title: 'HP',
    image: require('./img/advertiser/logos/hp.png')
  },
  {
    title: 'Wargaming',
    image: require('./img/advertiser/logos/wargaming.svg')
  },
  {
    title: 'Plarium',
    image: require('./img/advertiser/logos/plarium.png')
  },
  {
    title: 'Gaijin',
    image: require('./img/advertiser/logos/gaijin.png')
  },
  {
    title: 'Xsolla',
    image: require('./img/advertiser/logos/xsolla.svg')
  },
  {
    title: 'Marriott',
    image: require('./img/advertiser/logos/marriott.png')
  },
  {
    title: 'Agoda',
    image: require('./img/advertiser/logos/agoda.svg')
  },
  {
    title: 'Booking.com',
    image: require('./img/advertiser/logos/booking.svg')
  },
  {
    title: 'Skyscanner',
    image: require('./img/advertiser/logos/skyscanner.svg')
  },
]

export const ADVERTISER_LOGOS_PL = [
  {
    title: 'Aliexpress',
    image: require('./img/advertiser/logos/aliexpress.svg')
  },
  {
    title: 'Plarium',
    image: require('./img/advertiser/logos/plarium.png')
  },
  {
    title: 'Vivus',
    image: require('./img/advertiser/logos/vivuspl.svg')
  },
  {
    title: 'Zalando',
    image: require('./img/advertiser/logos/zalando.svg')
  },
  {
    title: 'Santander',
    image: require('./img/advertiser/logos/santander.png')
  },
  {
    title: 'Uber',
    image: require('./img/advertiser/logos/uber.svg')
  },
  {
    title: 'booking.com',
    image: require('./img/advertiser/logos/booking.svg')
  },
  {
    title: 'Wargaming',
    image: require('./img/advertiser/logos/wargaming.svg')
  },
  {
    title: 'Reiffeisen Bank',
    image: require('./img/advertiser/logos/raiffeisen.svg')
  },
  {
    title: 'CitiBank',
    image: require('./img/advertiser/logos/citibank.svg')
  },
  {
    title: 'Bradesco',
    image: require('./img/advertiser/logos/bradesco.png')
  },
  {
    title: 'Amazon',
    image: require('./img/advertiser/logos/amazon.svg')
  },
  {
    title: 'P&G',
    image: require('./img/advertiser/logos/png.svg')
  },
  {
    title: 'Mcdonalds',
    image: require('./img/advertiser/logos/mcdonalds.png')
  },
  {
    title: 'HP',
    image: require('./img/advertiser/logos/hp.png')
  },
  {
    title: 'Gaijin',
    image: require('./img/advertiser/logos/gaijin.png')
  },
  {
    title: 'Xsolla',
    image: require('./img/advertiser/logos/xsolla.svg')
  },
  {
    title: 'Marriott',
    image: require('./img/advertiser/logos/marriott.png')
  },
  {
    title: 'Agoda',
    image: require('./img/advertiser/logos/agoda.svg')
  },
  {
    title: 'Skyscanner',
    image: require('./img/advertiser/logos/skyscanner.svg')
  },
]

export const ADVERTISER_LOGOS_PT = [
  {
    title: 'Bauducco',
    image: require('./img/advertiser/logos/bauducco.png')
  },
  {
    title: 'Buscape',
    image: require('./img/advertiser/logos/buscape.svg')
  },
  {
    title: 'Zoom.com.br',
    image: require('./img/advertiser/logos/zoom.svg')
  },
  {
    title: 'Droga Raia',
    image: require('./img/advertiser/logos/drogaraia.png')
  },
  {
    title: 'Onofre',
    image: require('./img/advertiser/logos/onofre.png')
  },
  {
    title: 'Drogasil',
    image: require('./img/advertiser/logos/drogasil.png')
  },
  {
    title: 'Petz',
    image: require('./img/advertiser/logos/petz.svg')
  },
  {
    title: 'Nivea',
    image: require('./img/advertiser/logos/nivea.png')
  },
  {
    title: 'Jeep',
    image: require('./img/advertiser/logos/jeep.png')
  },
  {
    title: 'Johnson&Johnson',
    image: require('./img/advertiser/logos/johnsonnjohnson.png')
  },
  {
    title: 'KFC',
    image: require('./img/advertiser/logos/kfc.svg')
  },
  {
    title: 'Mcdonalds',
    image: require('./img/advertiser/logos/mcdonalds.png')
  },
  {
    title: 'Burger King',
    image: require('./img/advertiser/logos/burgerking.svg')
  },
  {
    title: 'J7',
    image: require('./img/advertiser/logos/j7.png')
  },
  {
    title: 'Pampers',
    image: require('./img/advertiser/logos/pampers.png')
  },
  {
    title: 'Best Buy',
    image: require('./img/advertiser/logos/bestbuy.svg')
  },
  {
    title: 'Mastercard',
    image: require('./img/advertiser/logos/mastercard.svg')
  },
  {
    title: 'Microsoft',
    image: require('./img/advertiser/logos/microsoft.png')
  },
  {
    title: 'Aliexpress',
    image: require('./img/advertiser/logos/aliexpress.svg')
  },
  {
    title: 'Peugeot',
    image: require('./img/advertiser/logos/peugeot.svg')
  },
  {
    title: 'eBay',
    image: require('./img/advertiser/logos/ebay.png')
  },
  {
    title: 'Amazon',
    image: require('./img/advertiser/logos/amazon.svg')
  },
  {
    title: 'Booking.com',
    image: require('./img/advertiser/logos/booking.svg')
  },
  {
    title: 'Skyscanner',
    image: require('./img/advertiser/logos/skyscanner.svg')
  },
  {
    title: 'Airbnb',
    image: require('./img/advertiser/logos/airbnb.png')
  },
  {
    title: 'Gaijin',
    image: require('./img/advertiser/logos/gaijin.png')
  },
  {
    title: 'Wargaming',
    image: require('./img/advertiser/logos/wargaming.svg')
  },
]


export const ADVERTISER_PARTNERS_BY_LANGUAGE = {
  ru: ADVERTISER_PARTNERS_RU,
  en: ADVERTISER_PARTNERS_EN,
  vi: ADVERTISER_PARTNERS_VI,
  pl: ADVERTISER_PARTNERS_PL,
  pt: ADVERTISER_PARTNERS_PT,
}

export const ADVERTISER_LOGOS_BY_LANGUAGE = {
  ru: ADVERTISER_LOGOS_RU,
  en: ADVERTISER_LOGOS_EN,
  vi: ADVERTISER_LOGOS_VI,
  pl: ADVERTISER_LOGOS_PL,
  pt: ADVERTISER_LOGOS_PT,
}
